import { FailureReason } from "../types";
import { ContentStatus } from "@/types/external-content";
export const SEARCH_THRESHOLD = 10; // Show the filter only once the list is long enough to warrant it.
export const TWO_COL_BREAKPOINT_PX = 1440; // Mirrors the SCSS $breakpoints "xxl" entry; Sass can't read JS constants, so keep the two in sync.
export const MAX_HOST_COUNT = 10;
export const MIN_DURATION_SECONDS = 60; // 1 minute
export const MAX_DURATION_SECONDS = 10800; // 3 hours
export const POLL_INTERVAL_MS = 3000;
export const AUDIO_MIME_PREFIX = "audio/";
export const DEFAULT_LIVE_MINUTES_RATIO = 2;
export const AUDIO_EXTENSIONS = new Set(["mp3", "wav", "aac", "flac", "ogg", "wma", "m4a"]);
export const PENDING_DELETE_TOAST_KEY = "externalContent:pendingDeleteToast";
export const UPLOAD_FAILURE_REASONS = new Set([
    FailureReason.TOO_LARGE,
    FailureReason.INVALID_FORMAT,
    FailureReason.TOO_SHORT,
    FailureReason.TOO_LONG,
    FailureReason.PASSWORD_PROTECTED
]);
// Failures at or past diarization re-run transcription on the existing file; earlier failures need a fresh upload.
export const RETRANSCRIBABLE_STATUSES = new Set([
    ContentStatus.DIARIZING,
    ContentStatus.BALANCE_DEDUCTION,
    ContentStatus.ANALYZING
]);
